<template>
    <div>
        <slot :url-config="urlConfig" />
    </div>
</template>

<script>
export default {
    name: "TgpBase",
    props: {
        joinUrl: {type: String, required: true},
        carryOverUrl: {type: String, required: true},
        defaultCarryOver: {type: String, default: ''},
        design: {type: String, required: true},
        tgpId: {type: Number, required: true},
    },

    computed: {
        urlConfig() {
            return {
                joinUrl: this.joinUrl,
                carryOverUrl: this.carryOverUrl,
                defaultCarryOver: this.defaultCarryOver,
            };
        },
    },
}
</script>
